import React from "react";
import styles from "./bancos.module.css";
import Titulo from "../titulo/titulo";
import Banco from "../banco/banco";
import icon_bcp from "../../../../img/icon_bcp.png";
import icon_scotiabank from "../../../../img/icon_scotiabank.jpg";
import icon_bbva from "../../../../img/icon_bbva.png";
import icon_caja_trujillo from "../../../../img/icon_caja_trujillo.png";
import icon_interbank from "../../../../img/icon_interbank.png";
import icon_caja_tacna from "../../../../img/icon_caja_tacna.jpg";

const Bancos = ({ codigo }) => {
    return (
        <div className={styles.container}>
            <Titulo
                titulo="Pago en Banca por Internet o Banca Móvil"
            />

            <div className={styles.tabla_bancos}>
                <div className={styles.banco}>
                    <Banco
                        icono={icon_bcp}
                        url="www.viabcp.com"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona la opción "Pagos y Transferencias" - "Pago de servicios". <br/>Selecciona "Empresas Diversas" - "SafetyPay" y el tipo de moneda.<br/>Ingresa tu código de pago <label style="color: #24A6C8">' + codigo + '</label>, verifica el monto, confirma el pago con tu clave token<br/>y ¡Listo!'}
                    />
                </div>

                <div className={styles.banco}>
                    <Banco
                        icono={icon_scotiabank}
                        url="www.scotiabank.com.pe"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona la opción "Pagos" - "Buscar empresas" - y digite "SafetyPay".<br/>Ingresa el código de pago <label style="color: #24A6C8">' + codigo + '</label>, y confirme el importe.<br/>Selecciona la cuenta de cargo y ¡Listo!'}
                    />
                </div>

                <div className={styles.banco}>
                    <Banco
                        icono={icon_bbva}
                        url="www.bbvacontinental.pe"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona "Pago de Servicios" - "Otras Opciones" - "Paga con SafetyPay".<br/>Ingresa tu código de pago <label style="color: #24A6C8">' + codigo + '</label>, monto a pagar y seleccione la cuenta cargo.<br/>Confirma la transacción y ¡Listo!'}
                    />
                </div>

                <div className={styles.banco}>
                    <Banco
                        icono={icon_caja_trujillo}
                        url="www.cajatrujillo.com.pe"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona la opción "Compras" - "Pago SafetyPay".<br/>Ingresa tu código de pago <label style="color: #24A6C8">' + codigo + '</label>, monto a pagar y verifica tu compra.<br/>Confirma la transacción y ¡Listo!'}
                    />
                </div>

                <div className={styles.banco}>
                    <Banco
                        icono={icon_interbank}
                        url="www.interbank.com.pe"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona la opción "Pago de recibos" - "Diversas Empresas".<br/>Selecciona la cuenta de cargo - Elige "SafetyPay".<br/>Ingresa tu código de pago <label style="color: #24A6C8">' + codigo + '</label>, verifica el monto y ¡Listo!'}
                    />
                </div>

                <div className={styles.banco}>
                    <Banco
                        icono={icon_caja_tacna}
                        url="www.cmactacna.com.pe"
                        descripcion={'Ingresa a tus cuentas por Banca por Internet o Banca Móvil<br/>Selecciona la opción "SafetyPay" - "Pago de Transacción".<br/>Ingresa tu código de pago <label style="color: #24A6C8">' + codigo + '</label> y monto a pagar.<br/>Confirma la transacción y ¡Listo!'}
                    />
                </div>
            </div>
        </div>
    )
}

export default Bancos;